var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dialog-button',_vm._b({staticStyle:{"background-color":"#FFF"},style:({ border: '0.1em solid #868686' }),on:{"click":function($event){return _vm.$emit('click')}}},'dialog-button',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }